import React from 'react';
import Divider from '@mui/material/Divider';
import { connect } from 'react-redux';

import { Flex } from '@/components/grid';
import {
  BlueCompareCarIcon,
  StyledContainer,
  StyledLabel,
  StyledSaferVariantCard,
  StyledVehicleDescription,
  StyledDetailLabel,
  StyledDetailValue,
  StyledLink,
  StyledLinkButton,
  StyledDetailList,
} from './styles';
import { getRelevantPriceForVehicle } from '@/utils/get-relevant-price-for-vehicle';
import { logTrackingEvent } from '@/utils/tracking';

import type { CompareActions } from '@/types/compare';
import { HsiycSearchVehiclesRecord } from '@/types/legacy-api/graphql';

type SaferVariantProps = {
  saferVariant: HsiycSearchVehiclesRecord;
  actions: CompareActions;
};

const SaferVariant = ({ saferVariant, actions }: SaferVariantProps) => {
  const {
    vehicleDescription,
    safetyFeaturesLinkedCount,
    totalRecommendedSafetyFeatures,
    newPrice,
    privateMinPrice,
    privateMaxPrice,
    redbookCode,
    uri,
  } = saferVariant;

  const hasPrivatePrice = privateMinPrice && privateMaxPrice;
  const priceLabel = hasPrivatePrice ? 'Private price guide' : 'Price guide';
  const priceValue = getRelevantPriceForVehicle({
    newPrice,
    privateMinPrice,
    privateMaxPrice,
  });

  const handleAddToCompare = () => {
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Argument of type 'Maybe<string> | undefined' is not assignable to parameter of type 'string'.
    actions.addToCompare(redbookCode);
    actions.openMiniCart();
    logTrackingEvent({
      event: 'addToCompareFromSaferVariant',
    });
  };

  return (
    <Flex className={null} justifyContent="flex-end">
      <StyledContainer role="complementary" aria-labelledby="safer-variant-heading">
        <StyledLabel id="safer-variant-heading">Safer Variant</StyledLabel>
        <StyledSaferVariantCard>
          <StyledVehicleDescription>{vehicleDescription}</StyledVehicleDescription>
          <Divider aria-hidden="true" />

          <StyledDetailList>
            <Flex
              className={null}
              justifyContent="space-between"
              alignItems="center"
              role="group"
              aria-label="Vehicle safety information"
            >
              <StyledDetailLabel id="safety-features-label">Recommended safety features</StyledDetailLabel>
              <StyledDetailValue aria-labelledby="safety-features-label">
                {safetyFeaturesLinkedCount}/{totalRecommendedSafetyFeatures}
              </StyledDetailValue>
            </Flex>

            <Flex
              className={null}
              justifyContent="space-between"
              alignItems="center"
              role="group"
              aria-label="Price information"
            >
              <StyledDetailLabel id="price-label">{priceLabel}</StyledDetailLabel>
              <StyledDetailValue aria-labelledby="price-label">{priceValue}</StyledDetailValue>
            </Flex>
          </StyledDetailList>

          <Flex className={null} justifyContent="space-between" alignItems="center">
            {uri && (
              <StyledLink href={`/${uri}`} aria-label={`View details for ${vehicleDescription}`}>
                Details
              </StyledLink>
            )}

            <StyledLinkButton
              onClick={handleAddToCompare}
              startIcon={<BlueCompareCarIcon aria-hidden="true" />}
              aria-label={`Add ${vehicleDescription} to compare`}
            >
              Add to compare
            </StyledLinkButton>
          </Flex>
        </StyledSaferVariantCard>
      </StyledContainer>
    </Flex>
  );
};

// @ts-expect-error - This will be done as part of the typing work.
const mapDispatch = (dispatch) => ({
  actions: {
    addToCompare: dispatch.compare.addToCompare,
    openMiniCart: dispatch.ui.openMiniCart,
  },
});

export const SaferVariantForTest = SaferVariant;

export default connect(null, mapDispatch)(SaferVariant);
